module.exports = __webpack_public_path__ + "media/images/icon_reload_white-c1886378b7aecbf7f85de3edcd29e258.svg";